export default __webpack_public_path__ + "img/chart-bar.e7195a73.svg";